/* Venora V2 — toda la logica de la pagina en un solo fichero cacheado.
   Antes iba inline en el HTML (unos 11 KB en cada carga). Ahora lo sirve
   el CDN de Shopify comprimido y el navegador lo guarda en cache. Va con
   defer, asi que no bloquea el pintado y el DOM ya esta listo al ejecutarse. */
(function(){
  var C = window.V2Config || {};
  var root = document.querySelector('.v2');
  if(!root || !C.offers) return;
  var sel = C.defaultOffer || 2;

  var HEX = {
    'Negro':'#1b1b1b','Café':'#4b3327','Cafe':'#4b3327','Carne':'#dcbb99','Beige':'#dcbb99',
    'Blanco':'#f3f1ec','Azul marino':'#1e2d4f','Gris':'#8f9296','Gris jaspeado':'#9a9c98'
  };
  function hex(n){ return HEX[n] || '#d9d9d9'; }

  var tallas = C.tallas || [], colores = C.colores || [];
  function tallaInicial(){
    var d = (C.tallaDefecto || '').trim().toLowerCase();
    for(var i=0;i<tallas.length;i++){
      var corta = String(tallas[i]).split(/[—\-(]/)[0].trim().toLowerCase();
      if(d && corta === d) return tallas[i];
    }
    return tallas[1] || tallas[0] || '';
  }
  var estado = { talla: tallaInicial(), colores: [] };

  function mx(cents){
    return '$' + (cents/100).toLocaleString('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
  }

  function variantId(){
    var c = estado.colores[0] || colores[0];
    var vs = C.variants || [];
    for(var i=0;i<vs.length;i++){ if(vs[i].t === estado.talla && vs[i].c === c) return vs[i].id; }
    for(var j=0;j<vs.length;j++){ if(vs[j].t === estado.talla) return vs[j].id; }
    return vs.length ? vs[0].id : null;
  }

  function nextBiz(){
    var d = new Date(); d.setDate(d.getDate()+1);
    while(d.getDay()===0 || d.getDay()===6){ d.setDate(d.getDate()+1); }
    return d.toLocaleDateString('es-MX',{weekday:'long',day:'numeric',month:'long'});
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-v2-fecha]'),function(el){ el.textContent = nextBiz(); });

  var main = document.getElementById('v2-gal-main');
  Array.prototype.forEach.call(document.querySelectorAll('[data-v2-thumb]'),function(b){
    b.addEventListener('click',function(){
      if(main){ main.removeAttribute('srcset'); main.src = b.getAttribute('data-v2-thumb'); }
      Array.prototype.forEach.call(document.querySelectorAll('[data-v2-thumb]'),function(o){ o.setAttribute('aria-current','false'); });
      b.setAttribute('aria-current','true');
    });
  });

  var guia = document.getElementById('v2-guia');
  document.addEventListener('click',function(ev){
    if(!guia) return;
    if(ev.target.closest && ev.target.closest('[data-v2-guia]')){ ev.preventDefault(); guia.classList.add('on'); return; }
    if(ev.target.closest && ev.target.closest('[data-v2-guia-close]')){ guia.classList.remove('on'); return; }
    if(ev.target === guia){ guia.classList.remove('on'); }
  });
  document.addEventListener('keydown',function(ev){ if(ev.key==='Escape' && guia) guia.classList.remove('on'); });

  function pintaColores(){
    var o = C.offers[sel-1], n = o.units || 1, pagados = o.paid || 1;
    while(estado.colores.length < n){ estado.colores.push(estado.colores[0] || colores[0]); }
    estado.colores.length = n;

    Array.prototype.forEach.call(document.querySelectorAll('[data-v2-npares]'),function(e){
      e.textContent = n + (n === 1 ? ' par' : ' pares');
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-v2-colores]'),function(cont){
      if(cont.childElementCount !== n){
        var html = '';
        for(var i=0;i<n;i++){
          var libre = i >= pagados;
          html += '<div class="v2-row"><span class="v2-row__l">Par ' + (i+1) + (libre ? '<em>GRATIS</em>' : '') + '</span><span class="v2-sw">';
          for(var k=0;k<colores.length;k++){
            var cn = colores[k];
            html += '<button type="button" data-v2-sw="' + i + '" data-c="' + cn.replace(/"/g,'&quot;') + '" style="--sw:' + hex(cn) + '" aria-pressed="false" aria-label="' + cn.replace(/"/g,'&quot;') + '" title="' + cn.replace(/"/g,'&quot;') + '"></button>';
          }
          html += '</span><span class="v2-row__n" data-v2-cn="' + i + '"></span></div>';
        }
        cont.innerHTML = html;
      }
      for(var j=0;j<n;j++){
        var val = estado.colores[j] || colores[0];
        Array.prototype.forEach.call(cont.querySelectorAll('[data-v2-sw="' + j + '"]'),function(b){
          b.setAttribute('aria-pressed', b.getAttribute('data-c') === val ? 'true' : 'false');
        });
        var lab = cont.querySelector('[data-v2-cn="' + j + '"]');
        if(lab) lab.textContent = val;
      }
    });
  }

  document.addEventListener('click',function(ev){
    var sw = ev.target.closest && ev.target.closest('[data-v2-sw]');
    if(sw){
      ev.preventDefault();
      estado.colores[parseInt(sw.getAttribute('data-v2-sw'),10)] = sw.getAttribute('data-c');
      pintaColores();
      return;
    }
    var same = ev.target.closest && ev.target.closest('[data-v2-same]');
    if(same){
      ev.preventDefault();
      var c0 = estado.colores[0] || colores[0];
      for(var i=0;i<estado.colores.length;i++){ estado.colores[i] = c0; }
      pintaColores();
    }
  });

  document.addEventListener('change',function(ev){
    var t = ev.target;
    if(t.hasAttribute && t.hasAttribute('data-v2-talla')){
      estado.talla = t.value;
      Array.prototype.forEach.call(document.querySelectorAll('[data-v2-talla]'),function(s){ s.value = estado.talla; });
    }
  });

  function paint(){
    var o = C.offers[sel-1];
    Array.prototype.forEach.call(document.querySelectorAll('[data-buy]'),function(box){
      box.querySelectorAll('[data-v2-offer]').forEach(function(btn){
        btn.setAttribute('aria-pressed', btn.getAttribute('data-v2-offer')===String(sel) ? 'true':'false');
      });
      var f = box.querySelector('[data-v2-final]'); if(f) f.textContent = mx(o.final);
      var c = box.querySelector('[data-v2-compare]'); if(c) c.textContent = mx(o.compare);
      var s = box.querySelector('[data-v2-save]'); if(s) s.textContent = (C.offerName||'OFERTA') + ' - Ahorras ' + mx(o.compare - o.final);
      var pf = box.querySelector('[data-v2-pill-final]'); if(pf) pf.textContent = mx(o.final);
      var pc = box.querySelector('[data-v2-pill-compare]'); if(pc) pc.textContent = mx(o.compare);
      box.querySelectorAll('[data-v2-gift]').forEach(function(g){
        var on = o.gifts.indexOf(parseInt(g.getAttribute('data-v2-gift'),10)) > -1;
        g.classList.toggle('off', !on);
        var fr = g.querySelector('.free'), lk = g.querySelector('.lock'), st = g.querySelector('s');
        if(fr) fr.style.display = on ? 'block':'none';
        if(st) st.style.display = on ? 'block':'none';
        if(lk) lk.style.display = on ? 'none':'block';
      });
      var ts = box.querySelector('[data-v2-talla]'); if(ts) ts.value = estado.talla;
    });
    pintaColores();
  }

  document.addEventListener('click',function(ev){
    var btn = ev.target.closest && ev.target.closest('[data-v2-offer]');
    if(!btn) return;
    ev.preventDefault();
    sel = parseInt(btn.getAttribute('data-v2-offer'),10) || 1;
    paint();
  });

  /* ---------- anadir al carrito ----------
     Rellenamos el formulario puente y lanzamos su submit.
     venora-cart.js lo escucha, quita el pack anterior, abre el cajon
     y repinta: el mismo carrito que en build 3.
     Si ese modulo no estuviera cargado, el submit no se cancela y
     caemos al metodo directo. */
  function post(url,payload){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)}).then(function(r){ return r.json(); });
  }

  function directo(vid,o,btn){
    btn.disabled = true;
    var props = { 'Talla': estado.talla, 'Colores': estado.colores.join(', ') };
    if(o.regalo) props['Te regalamos'] = o.regalo;
    post('/cart/add.js',{items:[{id:vid, quantity:o.paid, properties:props}]}).then(function(){
      if(window.V2SinRedirigir){ btn.disabled = false; return; }
      window.location.href = '/cart';
    }).catch(function(e){ console.error('[V2]', e); btn.disabled = false; });
  }

  document.addEventListener('click',function(ev){
    var btn = ev.target.closest && ev.target.closest('[data-v2-atc]');
    if(!btn) return;
    ev.preventDefault();
    var o = C.offers[sel-1];
    var vid = variantId();
    if(!vid) return;

    var form = document.getElementById('venora-form');
    if(!form){ directo(vid,o,btn); return; }

    form.querySelector('[data-v2-form-id]').value = vid;
    form.querySelector('[data-v2-form-qty]').value = o.paid;
    form.querySelector('[data-v2-form-talla]').value = estado.talla;
    form.querySelector('[data-v2-form-colores]').value = estado.colores.join(', ');

    var noCancelado = form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
    if(noCancelado){ directo(vid,o,btn); }
  });

  paint();
})();

/* ---------- contadores, sliders y linea de tiempo (antes v2-js2) ---------- */
(function(){
  var nums = document.querySelectorAll('[data-v2-num]');
  if(nums.length){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting || e.target.dataset.done) return;
        e.target.dataset.done = '1';
        var el = e.target, end = parseFloat(el.dataset.v2Num)||0;
        var pre = el.dataset.pre||'', suf = el.dataset.suf||'';
        var t0 = null, dur = 1100;
        function step(ts){
          if(!t0) t0 = ts;
          var k = Math.min(1,(ts-t0)/dur);
          k = 1 - Math.pow(1-k,3);
          el.textContent = pre + Math.round(end*k) + suf;
          if(k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },{threshold:.4});
    nums.forEach(function(n){ io.observe(n); });
  }

  document.querySelectorAll('[data-v2-slider]').forEach(function(sl){
    var t = sl.querySelector('.v2-sl__t');
    var dots = sl.querySelector('.v2-dots');
    var items = t ? t.children : [];
    if(!t || !items.length) return;
    if(dots){
      for(var i=0;i<items.length;i++){ dots.appendChild(document.createElement('i')); }
    }
    function idx(){
      var w = items[0].getBoundingClientRect().width + 12;
      return Math.round(t.scrollLeft / w);
    }
    function mark(){
      if(!dots) return;
      var k = idx();
      for(var i=0;i<dots.children.length;i++){ dots.children[i].classList.toggle('on', i===k); }
    }
    function go(d){
      var w = items[0].getBoundingClientRect().width + 12;
      t.scrollTo({left:(idx()+d)*w, behavior:'smooth'});
    }
    var p = sl.querySelector('.prev'), n = sl.querySelector('.next');
    if(p) p.addEventListener('click',function(){ go(-1); });
    if(n) n.addEventListener('click',function(){ go(1); });
    t.addEventListener('scroll', function(){ window.requestAnimationFrame(mark); }, {passive:true});
    mark();
  });

  var tl = document.querySelector('[data-v2-tl]');
  if(tl){
    var lis = tl.querySelectorAll(':scope > li');
    var io2 = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('on'); });
    },{threshold:.35});
    lis.forEach(function(l){ io2.observe(l); });
  }
})();
